import { AppLoaderProvider } from '@/contexts/AppLoaderContext';
import CustomDomainLandingPage from '@/pages/CustomDomainLandingPage';

export function SitesApp() {
  return (
    <AppLoaderProvider>
      <CustomDomainLandingPage />
    </AppLoaderProvider>
  );
}
